module.exports = __webpack_public_path__ + "img/lineup02@2x.b3690fba.png";